import { useState } from 'react'
import { useDemoFirstRunReset, useDemoFirstRunStatusQuery } from '../hooks/use-demo-first-run'
import { ClientAccountDemoFirstRunCardView } from './client-account-demo-first-run-card-view'

type CardProps = {
  accountId: string
  /** Quien no puede gestionar accesos ni siquiera consulta (el servidor igual respondería 403). */
  enabled: boolean
}

/**
 * La tarjeta «Cuenta de revisión de tiendas» (ADR 0041): sólo se dibuja si el estado responde 200,
 * y eso pasa únicamente para un visor de demo sobre la cuenta de revisión. En cualquier otro caso
 * (404, 403, cargando) no se renderiza nada y no hay aviso de error.
 */
export function ClientAccountDemoFirstRunCard({ accountId, enabled }: CardProps) {
  const query = useDemoFirstRunStatusQuery(accountId, enabled)
  const reset = useDemoFirstRunReset()
  const [confirmOpen, setConfirmOpen] = useState(false)

  return (
    <ClientAccountDemoFirstRunCardView
      status={query.data}
      isResetting={reset.isPending}
      confirmOpen={confirmOpen}
      onConfirmOpenChange={setConfirmOpen}
      onReset={() => {
        reset.mutate(accountId)
      }}
    />
  )
}
